import { getCosmetic, surfaceVeil } from '../../game/content/cosmetics';
import type { Progress } from '../../game/storage/progressStore';

export class BoardSkinPresenter {
  private readonly selected = { frame: '', background: '' };
  private readonly generation = { frame: 0, background: 0 };
  constructor(private readonly host: HTMLElement) {}
  update(profile: Progress): void {
    for (const [kind, id] of [['frame', profile.frameId], ['background', profile.backgroundId]] as const) {
      // A background change should not reload a frame that is already decoded.
      if (this.selected[kind] === id) continue;
      this.selected[kind] = id;
      const generation = ++this.generation[kind];
      const item = getCosmetic(id) ?? getCosmetic(kind === 'frame' ? 'frame-default' : 'background-default')!;
      const image = new Image(); image.src = item.image;
      void image.decode().then(() => {
        if (generation !== this.generation[kind]) return;
        if (kind === 'frame') {
          this.host.style.setProperty('--equipped-board-frame', `url("${item.image}")`);
          this.host.dataset.frame = item.id;
          this.host.dataset.frameAlpha = String(!item.initial);
          this.host.dataset.frameRarity = item.rarity;
        } else {
          this.host.style.setProperty('--equipped-board-surface', `url("${item.image}")`);
          this.host.style.setProperty('--skin-surface-veil', surfaceVeil(item));
          this.host.dataset.background = item.id;
          this.host.dataset.backgroundRarity = item.rarity;
          this.host.dataset.projection = String(Boolean(item.projection));
        }
      }).catch(() => { if (generation === this.generation[kind]) this.selected[kind] = ''; });
    }
  }
}
